import { useEffect, useState } from "react";
import { getCookie, CookieKeys } from "@lib/cookies";
import { getIsInIframe } from "@lib/iframe";
import { coerceBoolean } from "@lib/coerceBoolean";
import { selectClient } from "@store/client/clientReducer";
import { useAppSelector } from "@store/store";

export const useShowGdprCookieBanner = (): boolean => {
  const [hasConsent, setHasConsent] = useState(false);
  const [loading, setLoading] = useState(true);
  const client = useAppSelector(selectClient);

  useEffect(() => {
    (async () => {
      const cookieValue = await getCookie<boolean>(
        CookieKeys.hasConsent,
        false,
        coerceBoolean,
      );
      setHasConsent(cookieValue ?? false);
      setLoading(false);
    })();
  }, []);

  return (
    !loading && !hasConsent && !getIsInIframe() && !client.kioskFeature.enabled
  );
};
